/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aitextpostdescription3Inputs */

const en_aitextpostdescription3 = /** @type {(inputs: Aitextpostdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your post and let AI write the caption.`)
};

const de_aitextpostdescription3 = /** @type {(inputs: Aitextpostdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibe deinen Beitrag und lass die KI den Text schreiben.`)
};

/**
* | output |
* | --- |
* | "Describe your post and let AI write the caption." |
*
* @param {Aitextpostdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aitextpostdescription3 = /** @type {((inputs?: Aitextpostdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aitextpostdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aitextpostdescription3(inputs)
	return de_aitextpostdescription3(inputs)
});
export { aitextpostdescription3 as "aiTextPostDescription" }